export default function ({commit}) {
    commit('clean');
    commit('form/clean');
    commit('payment/clean');
    commit('reports/clean');
}